import { useQuery } from "react-query";
import { fetchSegmentationData } from "./api";

export function useSegmentation(filters, options = {}) {
  return useQuery(
    ["fetchSegmentationData", filters],
    () => fetchSegmentationData(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
